import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaShoppingCart, FaLeaf, FaWater, FaSeedling, FaRecycle, FaShieldAlt, FaExpand } from "react-icons/fa";

// Mock image - replace with actual image path
import cocopng from "../../assets/products/block1.png"; // Update with the actual image path

const Cocopeat1kgBricks = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [activeTab, setActiveTab] = useState('description');

  const whatsappNumber = "+919492228585";
  const whatsappMessage = encodeURIComponent(
    "Hello Mr.Ramana Sir! I'm interested in ordering the Cocopeat 1kg Bricks. Could you please provide more details?"
  );

  const handleOrderClick = () => {
    setShowOptions(!showOptions);
  };

  const benefits = [
    { icon: <FaLeaf />, title: "100% Organic", desc: "Natural and eco-friendly growing medium" },
    { icon: <FaWater />, title: "Superior Water Retention", desc: "Holds up to 20L water for optimal plant growth" },
    { icon: <FaExpand />, title: "Expands 15L", desc: "Compact brick expands to 15 liters when hydrated" },
    { icon: <FaShieldAlt />, title: "Pathogen-Free", desc: "Safe and healthy growing environment" },
    { icon: <FaSeedling />, title: "Perfect pH", desc: "Ideal pH range of 5.5-6.3 for plants" },
    { icon: <FaRecycle />, title: "Eco-Friendly", desc: "Sustainable and environmentally conscious choice" }
  ];

  const specifications = [
    { param: "Dimensions", value: "20 cm x 10 cm x 5 cm" },
    { param: "Material", value: "100% Coco Peat" },
    { param: "Weight", value: "1 kg" },
    { param: "Expansion", value: "Up to 15 L" },
    { param: "Water Holding", value: "Around 20 L" },
    { param: "EC Level", value: "EC 0.2 to EC 1.5 mS/cm" },
    { param: "pH Value", value: "5.5 - 6.3" }
  ];

  return (
    <div className="min-h-screen bg-gray-50 shadow-md my-10">

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-green-50 to-green-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Product Image */}
            <div className="order-1 lg:order-1">
              <div className="relative bg-white rounded-2xl shadow-xl p-6 lg:p-8">
                <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  1kg
                </div>
                <img
                  src={cocopng}
                  alt="Cocopeat 1kg Bricks"
                  className="w-full h-64 sm:h-80 lg:h-96 object-contain rounded-lg"
                />
              </div>
            </div>

            {/* Product Info */}
            <div className="order-2 lg:order-2 space-y-6">
              <div>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                  Cocopeat 1kg Bricks
                </h1>
                <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
                  Premium quality coco peat brick perfect for small-scale gardening and home plants. Compact, lightweight, and expands to 15 liters when hydrated for excellent value.
                </p>
              </div>

              <div className="flex flex-wrap gap-2">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                  <FaLeaf className="mr-1" /> 100% Organic
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  <FaWater className="mr-1" /> Superior Water Retention
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
                  <FaShieldAlt className="mr-1" /> Pathogen-Free
                </span>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-lg">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Key Features</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex items-center space-x-2">
                    <FaExpand className="text-green-600" />
                    <span className="text-gray-700">Expands to 15L</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaWater className="text-blue-600" />
                    <span className="text-gray-700">20L Water Holding</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaSeedling className="text-green-600" />
                    <span className="text-gray-700">pH 5.5-6.3</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <FaRecycle className="text-purple-600" />
                    <span className="text-gray-700">Eco-Friendly</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Product Details Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Tabs */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2 sm:gap-4 border-b border-gray-200">
            {['description', 'specifications', 'benefits'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 text-sm sm:text-base font-medium capitalize transition-colors duration-200 border-b-2 ${
                  activeTab === tab
                    ? 'text-green-600 border-green-600'
                    : 'text-gray-500 border-transparent hover:text-green-600 hover:border-green-300'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-xl shadow-lg p-6 lg:p-8">
          {activeTab === 'description' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Product Description</h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                Tirumala Cocopeat 1kg Brick is a lightweight, compact product, perfect for small-scale gardening. When hydrated, it expands up to 15 liters, offering excellent water retention and aeration properties, making it ideal for flowers, vegetables, and ornamental plants. It is completely organic, eco-friendly, and free from weeds or pathogens, ensuring a healthy environment for your plants.
              </p>
              <div className="bg-green-50 border-l-4 border-green-400 p-4">
                <p className="text-green-800 font-medium">
                  💡 Pro Tip: Soak the brick in water for 20-30 minutes to achieve full expansion and optimal texture for your plants.
                </p>
              </div>
              <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
                <h4 className="font-semibold text-blue-800 mb-2">Perfect For:</h4>
                <ul className="text-blue-700 space-y-1">
                  <li>• Small-scale gardening and home plants</li>
                  <li>• Seed germination and seedling development</li>
                  <li>• Hydroponics and soil-less cultivation</li>
                  <li>• Improving soil aeration and moisture retention</li>
                </ul>
              </div>
            </div>
          )}

          {activeTab === 'specifications' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Technical Specifications</h2>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse bg-white">
                  <thead>
                    <tr className="bg-green-50">
                      <th className="border border-gray-300 p-4 text-left font-semibold text-gray-900">Parameter</th>
                      <th className="border border-gray-300 p-4 text-left font-semibold text-gray-900">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {specifications.map((spec, index) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                        <td className="border border-gray-300 p-4 font-medium text-gray-700">{spec.param}</td>
                        <td className="border border-gray-300 p-4 text-gray-700">{spec.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {activeTab === 'benefits' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-gray-900">Key Benefits</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {benefits.map((benefit, index) => (
                  <div key={index} className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-md transition-shadow duration-200">
                    <div className="text-3xl text-green-600 mb-3 flex justify-center">{benefit.icon}</div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.desc}</p>
                  </div>
                ))}
              </div>
              <div className="bg-gray-50 rounded-xl p-6 mt-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Additional Benefits</h3>
                <ul className="text-gray-700 space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">✓</span>
                    Ideal for small-scale gardening and home plants
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">✓</span>
                    Improves soil aeration, moisture retention, and plant growth
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">✓</span>
                    Weed and pathogen-free for healthy gardening
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-600 mr-2">✓</span>
                    Convenient size, easy to store and use
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-green-600 to-green-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold">Ready to Transform Your Garden?</h2>
            <p className="text-xl text-green-100 max-w-2xl mx-auto">
              Get your premium 1kg cocopeat brick today and give your plants the perfect growing medium they deserve.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-green-600 px-8 py-3 rounded-full font-semibold text-lg hover:bg-green-50 transition-all duration-300 flex items-center space-x-2 hover:scale-105"
              >
                <FaWhatsapp className="text-xl" />
                <span>Order via WhatsApp</span>
              </a>
              <a
                href={`tel:${whatsappNumber}`}
                className="bg-green-800 text-white px-8 py-3 rounded-full font-semibold text-lg hover:bg-green-900 transition-all duration-300 flex items-center space-x-2 hover:scale-105"
              >
                <FaPhoneAlt className="text-xl" />
                <span>Call Now</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Action Button */}
      <div
        onClick={handleOrderClick}
        className="fixed bottom-6 right-6 bg-green-600 text-white p-4 rounded-full shadow-xl hover:bg-green-700 transition-all duration-300 cursor-pointer hover:scale-110 z-50"
      >
        <FaShoppingCart className="text-xl" />
      </div>

      {/* Floating Options Menu */}
      <div
        className={`fixed bottom-24 right-6 transform transition-all duration-300 ease-in-out z-40 ${
          showOptions
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10 pointer-events-none"
        }`}
      >
        <div className="bg-white shadow-xl rounded-xl p-4 space-y-3 border">
          <a
            href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-3 bg-green-600 text-white px-4 py-3 rounded-lg hover:bg-green-700 transition-all duration-300 hover:scale-105"
          >
            <FaWhatsapp className="text-xl" />
            <span className="font-medium">WhatsApp</span>
          </a>
          <a
            href={`tel:${whatsappNumber}`}
            className="flex items-center space-x-3 bg-blue-600 text-white px-4 py-3 rounded-lg hover:bg-blue-700 transition-all duration-300 hover:scale-105"
          >
            <FaPhoneAlt className="text-xl" />
            <span className="font-medium">Call Now</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Cocopeat1kgBricks;